import {EResellerIds} from 'src/containers/User';

import {ELeadClientStatus, ERegistrationType, EU_COUNTRIES} from './definitions';

export const isLeadHasTenant = (status?: string) =>
  !!status &&
  [ELeadClientStatus.ACCEPTED, ELeadClientStatus.ERROR].includes(status as ELeadClientStatus);

export const getTaxNumberLabel = ({
  resellerId,
  countryCode,
}: {
  resellerId?: EResellerIds;
  countryCode?: string;
}) => {
  if (resellerId && [EResellerIds.BLR_FIRST_ID, EResellerIds.BLR_SECOND_ID].includes(resellerId)) {
    return 'blrTaxNumber';
  }

  if (resellerId === EResellerIds.KZ_ID) {
    return 'binNumber';
  }

  if (countryCode && EU_COUNTRIES.includes(countryCode)) {
    return 'vatNumber';
  }

  return 'taxNumber';
};

export const mapVatNumberValue = (value?: string) => value?.toUpperCase().replace(/[^\dA-Z]/g, '');

export const getSelfRegistrationFilter = (
  registrationType?: Record<ERegistrationType, boolean>,
) => {
  if (registrationType?.SELF_SERVICE && !registrationType?.ADMIN_CREATED) {
    return true;
  }

  if (registrationType?.ADMIN_CREATED && !registrationType?.SELF_SERVICE) {
    return false;
  }

  return null;
};
